import React from 'react';
import { Route } from 'react-router';

import {
  ConfigurationUpload,
  ConfigurationUploadNew,
  HierarchyUpload,
  BridgeConfiguration,
  EdgeConfiguration,
  ParameterHierarchy,
  ValidConfiguration,
  TopicMaster,
  TopicList
} from '../pages';

export default class ApplicationSettingsRouter extends React.Component {
  render() {
    return (
      <div>
        <Route
          path="/rubus/configurationSettings/configurationUpload"
          component={ConfigurationUpload}
        />
        <Route
          path="/rubus/configurationSettings/configurationUploadNew"
          component={ConfigurationUploadNew}
        />
        <Route path="/rubus/configurationSettings/hierarchyUpload" component={HierarchyUpload} />
        <Route
          path="/rubus/configurationSettings/BridgeConfiguration"
          component={BridgeConfiguration}
        />
        <Route
          path="/rubus/configurationSettings/EdgeConfiguration"
          component={EdgeConfiguration}
        />
        <Route
          path="/rubus/configurationSettings/ValidationConfiguration"
          component={ValidConfiguration}
        />
        <Route path="/rubus/configurationSettings/TopicMaster" component={TopicMaster} />
        <Route path="/rubus/configurationSettings/TopicList" component={TopicList} />
        <Route
          path="/rubus/configurationSettings/ParameterHierarchy"
          component={ParameterHierarchy}
        />
      </div>
    );
  }
}
